const getModuleState = (state) => state.blogs;

export const getAllBlogs = (state) => getModuleState(state).allBlogs;
export const getRecentBlogs = (state) => getModuleState(state).recentBlogs;
export const getAllBlogsPaged = (state) => getModuleState(state).allBlogsPaged;
export const getBlogById = (state) => getModuleState(state).blogById;
export const getBlogBySlug = (state) => getModuleState(state).blogBySlug;
export const getAllCategoryBlogs = (state) => getModuleState(state).allCategoryBlogs;
export const getCategoryBlogById = (state) => getModuleState(state).categoryBlogById;